import React, { useState, useEffect } from "react";
import "../styles/Home.css";
import Showroom from "../assets/images/squarefeet-marble-showroom.webp";
import Collection from "../assets/images/collection.webp";
import third from "../assets/products/bianco-oromarble2.webp";
import fourth from "../assets/products/statuariohallarea.webp";
import ValuesPage from "../pages/Values.js";
import TestimonialsPage from "../pages/Testimonials.js";
import MichaelAngelo from"../assets/images/michael-angelo-imported-marble-showcase.webp"
import PristineWhite from"../assets/images/pristine-white-imported-marble-showcase.webp"
import SEO from "../components/SEO.js";
const slides = [
{
  title: "Our Showroom",
  subtitle: "Visit the Square Feet Marble Showroom to experience our exclusive range of premium marble in its true beauty. Designed for architects, designers, and homeowners, our showroom offers inspiration for every luxury project.",
  image: Showroom,
},
  {
    title: "Discover Our Marble Gallery",
    subtitle: "Explore a curated collection of the finest Imported and Italian marbles, handpicked for luxury interiors.Our Marble Gallery showcases elegant colors, unique textures, and premium finishes for every design style",
    image: Collection,
  },
  {
  title: "Michael Angelo Marble",
  subtitle: "Where strength meets beauty — a rare blend of milky white, pink, and peach tones with crystal clarity that feels alive in every glance.",
  image: MichaelAngelo,
},
  {
    title: "Pristine White Marble",
    subtitle: "A canvas of pure elegance — where bold and subtle textures unite to create timeless sophistication.",
    image: PristineWhite,
  },
  {
    title: "Bianco Oro marble",
    subtitle: "White marble adorned with golden artistry — a symbol of opulence crafted by nature itself.",
    image: third,
  },
  {
    title: "Italian Statuario ",
    subtitle: "The marble of legends — pure white elegance with graceful grey veining that transforms interiors into classical art.",
    image: fourth,
  },
];

const Home = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [paused] = useState(false);

  const nextSlide = () => {
    setActiveIndex((prev) => (prev + 1) % slides.length);
  };

  useEffect(() => {
    if (!paused) {
      const interval = setInterval(nextSlide, 6000);
      return () => clearInterval(interval);
    }
  }, [paused]);

  return (
    <div className="home-container">
    <SEO
  title="Best Imported & Italian Marble Supplier in Kishangarh, India | Square Feet Marble"
  description="India’s most trusted names in Imported Marble, Italian Marble, and Premium Natural Stones. As the Best Imported Marble Supplier & Dealer in Kishangarh, India, we specialize in offering handpicked luxury marble sourced from the finest quarries of Italy, Turkey, Spain, Greece, Vietnam, and Brazil. Based in Kishangarh – the Marble Capital of India, we bring more than 55 + years of industry expertise in delivering world-class marble that meets the highest standards of purity, durability, and aesthetics."
  keywords="Square Feet Marble, best imported marble, top marble supplier, imported marble India, imported marble Kishangarh, marble dealer, marble showroom, imported marble collection , Italian marble supplier, luxury marble, premium natural stones, marble for architects, marble for interior designers, high-end marble, exotic marble, marble slabs, wholesale marble, marble for villas, marble for hotels"
  canonical="https://www.squarefeetmarble.com/"
  ogImage="https://www.squarefeetmarble.com/imported-marble-kishangarh-stockyard-2.webp"
  

/>
  {/* === MAGAZINE SECTION === */}
  <section id="magazine">
    <div className="magazine-content">    
      {/* LEFT SIDE - SLIDES */}
      <div className="magazine-left">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`magazine-slide ${index === activeIndex ? "active" : ""}`}
          >
            <div
              className="magazine-slide-bg"
              style={{ backgroundImage: `url(${slide.image})` }}
            ></div>
          </div>
        ))}

        {/* SLIDE INDICATORS */}
        <div className="magazine-indicators">
          {slides.map((_, index) => (
            <span
              key={index}
              className={`indicator ${index === activeIndex ? "active" : ""}`}
              onClick={() => setActiveIndex(index)}
            ></span>
          ))}
        </div>

        {/* NAVIGATION ARROWS */}
        <div className="magazine-nav-arrows">
          <button
            className="magazine-arrow"
            onClick={() =>
              setActiveIndex((activeIndex - 1 + slides.length) % slides.length)
            }
          >
            <i className="fas fa-chevron-left"></i>
          </button>
          <button
            className="magazine-arrow"
            onClick={() => setActiveIndex((activeIndex + 1) % slides.length)}
          >
            <i className="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>

      {/* RIGHT SIDE - CONTENT */}
      <div className="magazine-right">
        <div className="magazine-date">SQUARE FEET MARBLE</div>
        <h2>{slides[activeIndex].title}</h2>
        <h4>{slides[activeIndex].subtitle}</h4>
        <a href="/imported-marble" className="read-more">
          Explore Collection <i className="fas fa-arrow-right"></i>
        </a>
      </div>
    </div>
  </section>

{/* ABOUT / WHO WE ARE */}
<section id="about" className="sfm-about">
  <div className="container about-container no-image">

    <div className="about-right">
      <h1>Best Imported Marble Supplier in Kishangarh, India - Square Feet Marble </h1>

 <p>
<strong>Square Feet Marble</strong> is a leading supplier of 
<strong> <a href="/imported-marble"> imported marble</a>, Italian marble, and premium natural stones</strong> 
based in <strong>Kishangarh, Rajasthan</strong> — which is widely known as the 
<strong> Marble Capital of India</strong>.
</p>
<p>
With over <strong>five decades of industry experience</strong>, we specialize in 
sourcing, processing, and supplying high-quality marble from renowned quarries 
across <strong> Portugal, Italy, Turkey, Greece, Spain, Vietnam, and Brazil</strong>. 
Our focus is on premium-grade stone that meets modern architectural and interior 
design standards.
</p>


<p>
  Our commitment to quality and craftsmanship has made us a preferred brand for  
  <strong> architects, interior designers, builders, developers, and premium homeowners </strong> 
  across India. From large villas and luxury apartments to 5-star hotels and commercial 
  spaces, Square Feet Marble provides the finest imported marble solutions tailored 
  to every project’s design needs.
</p>

<p>
  With certified quality, transparent pricing, and a curated selection of  
  <strong> Italian Statuario, Angelo White, Michael Angelo, Bianco Oro, Swiss White </strong>  
  and other exotic marbles, we continue to lead the industry as the  
  <strong> Best Imported Marble Supplier in Kishangarh, India</strong>,  
  delivering unmatched service and premium materials for modern, elegant spaces.
</p>

<h2>Trusted Marble Partner for Luxury Residential & Commercial Projects</h2>

<p>
Square Feet Marble is trusted by <strong>architects, interior designers, builders, 
developers, and premium homeowners</strong> across India. Our marble is widely used 
in <strong>luxury villas, high-end apartments, hotels, corporate spaces, and bespoke interiors</strong>.
</p>

<h2>Why Architects & Designers Choose Square Feet Marble</h2>

<p>
Every marble slab is carefully selected and quality-checked for 
<strong>vein consistency, surface finish, durability, colour tone, and natural strength</strong>. 
This ensures reliability and long-term performance in premium projects.
</p>

<ul className="key-list">
  <li>Direct importers of Italian and exotic marble</li>
  <li>Large ready stock available in Kishangarh</li>
  <li>Expertise in book-matching and precision cutting</li>
  <li>Transparent pricing and professional guidance</li>
  <li>Pan-India delivery with safe logistics handling</li>
</ul>

<h2>Our Premium Marble Collections</h2>

<p>
Our stockyard in Kishangarh houses a curated range of imported and luxury marble 
suitable for both contemporary and classic interior designs.
</p>

<ul className="key-list">
  <li>
    <a href="/imported-marble/michael-angelo">
      Michael Angelo Marble
    </a> – A signature choice for luxury living spaces
  </li>
  <li>
    <a href="/imported-marble/statuario">
      Italian Statuario Marble
    </a> – Ideal for ultra-premium interiors
  </li>
  <li>
    <a href="/exotic-imported-marble">
      Exotic Imported Stones
    </a> – Unique colours and bold patterns
  </li>
  <li>
    <a href="/beige-imported-marble">
      Beige & Cream Marble
    </a> – Warm, elegant, and timeless finishes
  </li>
</ul>
<h2>Experience the Marble Before You Choose</h2>

<p>
Clients are welcome to visit our Kishangarh showroom to view slabs in natural light, 
understand surface finishes, and receive expert assistance in selecting the right stone 
for their project requirements.
</p>

<p>
Our team also supports customers with <strong>quantity estimation, layout planning, 
cutting guidance, and installation recommendations</strong>, ensuring a seamless 
experience from selection to execution.
</p>

      <h2>Our Vision & Commitment</h2>
      <p>
        Our vision is to provide <strong>world-class marble at honest pricing</strong> with  
        unmatched service and long-lasting value. Whether you are building a home,  
        renovating an office, or designing a luxury hotel—Square Feet Marble provides  
        a premium stone selection that transforms every project into an architectural masterpiece.
      </p>

      <a href="/contact" className="btn-outline">Request a Quote</a>
    </div>

  </div>
</section>
  {/* === VALUES SECTION === */}
  <section className="home-values">
    <ValuesPage />
  </section>

  {/* === TESTIMONIALS SECTION === */}
  <section className="home-testimonials">
    <TestimonialsPage />
  </section>
</div>

  );
};

export default Home;
